import React from "react";
import { useNavigate } from "react-router-dom";
import { EMAIL_SUPPORT_LINK_CLICKED, SCHEDULE_A_CALL_CLICK, trackEvent } from "../../analytics";
import { MEETING_SCHEDULE_LINK } from "../../constants/constants";
import Card from "../Card/Card";
import InvertedPrimaryButton from "../InvertedPrimaryButton/InvertedPrimaryButton";
import Typography from "../Typography/Typography";

const ContactSalesCard = ({ isComplianceFormFilled, onClick }) => {
  const navigate = useNavigate();
  const onlyOnce = React.useRef(true);
  // return isComplianceFormFilled ? (
  //   <>
  //     <Card className="contact-sales-card">
  //       <Typography className="contact-sales-card-header" style={{ marginTop: "16px" }} h3>
  //         Applied for production access!
  //       </Typography>
  //       <span className="contact-sales-card-description">Our team will be in touch with you shortly.</span>
  //       <span className="contact-sales-card-description">
  //         Got questions? Email{" "}
  //         <a href="mailto:support@getphyllo.com">
  //           <u>support@getphyllo.com.</u>
  //         </a>
  //       </span>
  //     </Card>
  //   </>
  // ) : (
  return (
    <>
      <Card className="contact-sales-card">
        <Typography className="contact-sales-card-header" style={{ marginTop: "16px" }} h3>
          Talk to us!
        </Typography>
        <span className="contact-sales-card-description">
          For a product demo or to get production access, email us at{" "}
          <a href="mailto:business@getphyllo.com" style={{ color: "#2262ED" }} target="_blank">
            <u
              onClick={() => {
                onlyOnce.current = false;
                trackEvent(EMAIL_SUPPORT_LINK_CLICKED, { source: "LEFT_NAV" });
              }}
            >
              business@getphyllo.com
            </u>
          </a>{" "}
          OR
        </span>
        <InvertedPrimaryButton
          label="Schedule a call"
          onClick={() => {
            trackEvent(SCHEDULE_A_CALL_CLICK, { link: MEETING_SCHEDULE_LINK, source: "LEFT_NAV" });
            window.open(MEETING_SCHEDULE_LINK, "_blank");
          }}
          style={{ margin: "auto", display: "block" }}
        />
      </Card>
    </>
  );
};

export default ContactSalesCard;
